import { useState } from "react";
import styled from "@emotion/styled";
import { blue } from "../color";
import { OutlinedInput, InputAdornment, IconButton } from "@mui/material";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const FillWidth = styled.div`
padding: 1rem;
background-color: ${blue[900]};
position: fixed;
bottom: 0;
width: -webkit-fill-available;
`;

const CustomTextField = styled(OutlinedInput)`
box-shadow: 4px 4px 0px 0px rgba(0, 0, 0, 0.4);
background-color: white;
`;

const CustomIconButton = styled(IconButton)`
  margin-right: 2.5rem;
  @media (max-width: 768px) {
    margin-right: 2rem;
  }
`;

const InputBlock = ({
  onQuestionChange,
  setBlackScreen,
  setQueryIndex,
  setDynamicCodeSection
}) => {
  const params = new URLSearchParams(window.location.search);
  const [question, setQuestion] = useState("");


  const handleFormSubmission = (event) => {
    event.preventDefault();
    onQuestionChange(question);
    setQuestion("");
    params.set("q", question);
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.pushState({ path: newUrl }, '', newUrl);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleClickRotate = () => {
    setBlackScreen(true);
    setDynamicCodeSection(false);
    setQueryIndex(0);
    setQuestion("");
    params.set("q", "new");
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.pushState({ path: newUrl }, '', newUrl);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <>
      <FillWidth>
        <form onSubmit={handleFormSubmission} disabled={!question}>
          <CustomTextField
            id="input"
            placeholder="Type your message here, it typically takes a few seconds"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            fullWidth
            autoComplete="input"
            endAdornment={
              <InputAdornment position="end">
                <CustomIconButton onClick={handleClickRotate} edge="end">
                  <RotateLeftIcon
                    color="primary"
                  />
                </CustomIconButton>
                <IconButton onClick={handleFormSubmission} edge="end">
                  <ArrowForwardIcon color="primary" />
                </IconButton>
              </InputAdornment>
            }
          />
        </form>
      </FillWidth>
    </>
  );
};
export default InputBlock;
